export default {"src":"/_next/static/media/whoop-logo-round-white.9dabfb96.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};